import { render } from "./MainCongTy.vue?vue&type=template&id=38ab04b0"
import script from "./MainCongTy.vue?vue&type=script&lang=js"
export * from "./MainCongTy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__